const initialState = {
	languagesData: [],
	translationData: {},
	languageCodes: []
};

const languageTransReducer = (state = initialState, action) => {
    if (action.type === 'LANGUAGE_DATA') {
		return Object.assign({}, state, {
            languagesData: action.languagesData
		});
	}
	if (action.type === 'TRANSLATION_DATA') {
		return Object.assign({}, state, {
			translationData: action.translationData
		});
	}
	if (action.type === 'LANGUAGE_CODES') {
		return Object.assign({}, state, {
			languageCodes: action.languageCodes
		});
	}
    return state;
};

export default languageTransReducer;


// WEBPACK FOOTER //
// ./src/reducers/languageTransReducer.js